import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export function initNumberCounters(selector = '.number-revealer') {
	// Sélectionne tous les éléments correspondant au sélecteur
	const allNumberCounter = document.querySelectorAll(selector);

	// Si aucun élément n'est trouvé, on arrête la fonction
	if (!allNumberCounter.length) return;

	// Fonction utilitaire pour extraire la valeur cible et le suffixe
	function parseTargetAndSuffix(el) {
		// Récupère les attributs data-target et data-suffix
		const dataTarget = el.getAttribute('data-target');
		const dataSuffix = el.getAttribute('data-suffix') || '';

		// Cas 1 : si data-target est défini
		if (dataTarget != null && dataTarget !== '') {
			const n = Number(dataTarget);
			// Retourne la valeur cible (ou 0 si invalide) et le suffixe
			return { target: Number.isFinite(n) ? n : 0, suffix: dataSuffix };
		}

		// Cas 2 : sinon, on essaie de parser le texte existant
		const text = (el.textContent || '').trim();
		// Regex qui sépare le nombre et le reste du texte (suffixe)
		const match = text.match(/^([0-9]+(?:\.[0-9]+)?)(.*)$/);
		if (match) {
			const n = Number(match[1]);
			return { target: Number.isFinite(n) ? n : 0, suffix: match[2].trim() };
		}
		// Si rien n'est valide, on retourne 0 sans suffixe
		return { target: 0, suffix: '' };
	}

	// Pour chaque élément trouvé
	allNumberCounter.forEach(el => {
		// On détermine la valeur cible et le suffixe
		const { target, suffix } = parseTargetAndSuffix(el);
		// On initialise le texte à "0" + suffixe
		el.textContent = `0${suffix}`;

		// Création d'un ScrollTrigger pour déclencher l'animation
		ScrollTrigger.create({
			trigger: el,        // L'élément déclencheur
			start: 'top 80%',   // Quand le haut de l'élément atteint 80% du viewport
			once: true,         // L'animation ne se joue qu'une seule fois
			// invalidateOnRefresh: true, // Recalculer en cas de resize

			// Callback quand l'élément entre dans la zone
			onEnter: () => {
				// Objet compteur utilisé par GSAP
				const counter = { val: 0 };
				// Animation GSAP qui fait passer val de 0 à la cible
				gsap.to(counter, {
					val: target,          // Valeur finale
					duration: 1,          // Durée de l'animation (1 seconde)
					ease: 'power2.out',   // Courbe d'accélération/décélération
					onUpdate: () => {
						// À chaque mise à jour, on arrondit la valeur
						const v = Math.floor(counter.val);
						// On met à jour le texte de l'élément avec la valeur + suffixe
						el.textContent = `${v}${suffix}`;
					},
				});
			},
		});
	});
}